import { render, staticRenderFns } from "./Run.vue?vue&type=template&id=35a72588"
import script from "./Run.vue?vue&type=script&lang=js"
export * from "./Run.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports